import { useState, useMemo } from 'react'
import { User } from '@/types/user'

export function useUserFilters(users: User[]) {
  const [selectedCargo, setSelectedCargo] = useState<string>('Todos')
  const [searchTerm, setSearchTerm] = useState<string>('')
  
  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      const matchesCategory = selectedCargo === 'Todos' || user.typeCargo === selectedCargo
      const matchesSearchTerm =
        user.cpf?.includes(searchTerm) ||
        user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase())

      return matchesCategory && matchesSearchTerm
    })
  }, [users, selectedCargo, searchTerm])
  
  return {
    filteredUsers,
    searchTerm,
    setSearchTerm,
    selectedCargo,
    setSelectedCargo
  }
}